import { GroupedEntity } from "../../../../../core";

export const groupEntity = {
  searchText: "",
  addText: "Agregar agrupación",
  export: false,
  filter: false,
  checkbox: false,
  disabled: false,
  partialField: "",
  columns: [
    {
      title: "Agrupación",
      name: "groupName",
      type: "string",
      checkAll: false,
      editable: false,
      value: (element: GroupedEntity) => element.groupName,
    },
    {
      title: "Número de entidades",
      name: "number",
      type: "string",
      checkAll: false,
      editable: false,
      value: (element: GroupedEntity) =>  element.entityCodes ? element.entityCodes.split(",").length: '',
    },
    {
      title: "Entidades",
      name: "entities",
      type: "string",
      editable: false,
      checkAll: false,
      value: (element: GroupedEntity) => element.entityNames,
    },
    {
      title: 'Activo',
      name: 'groupedEntityEnabled',
      type: 'boolean',
      editable: true,
      toggleValue: () => true,
      checkAll: false,
      class: 'center',
      value: (element: GroupedEntity) => element.groupedEntityEnabled
    }
  ],
};
